import React from "react";
import { MRT_ColumnDef } from "material-react-table";

/**
 * MRT has no flag to toggle individual default column-menu items (e.g. "Clear
 * filter"), so we intercept the rendered list and filter by label, reaching
 * into the `MenuItem > Box > [ListItemIcon, label]` structure to read it.
 */
export const excludeColumnMenuItems = (
  labelsToHide: string[],
): NonNullable<MRT_ColumnDef<any>["renderColumnActionsMenuItems"]> => ({ internalColumnMenuItems }) =>
  internalColumnMenuItems.filter((item) => {
    if (!React.isValidElement(item)) {
      return true;
    }
    const label = (item as any)?.props?.children?.props?.children?.[1];
    return !labelsToHide.includes(label);
  });
